import {Database} from '@tnc/shared';
import {Link} from 'react-router';

import {DataTableRpc, DataTableRpcRefT} from '@/components/dataTableRpc';

import {useExchangeOrder} from '../providers/exchangeOrder';

const filterBtns = [
  {
    class: 'primary',
    label: 'Category',
  },
  {
    class: 'secondary',
    label: 'Sub Category',
  },
];

type ProductSelectionModalPropsT = {
  marketId: number;
  brandId?: number;
  type: 'buy' | 'sell' | 'transfer' | undefined;
  productRef?: React.RefObject<DataTableRpcRefT>;
};

function ProductSelectionModal({marketId, brandId, type, productRef}: ProductSelectionModalPropsT) {
  // Hooks
  const {selectSellOrderProduct, selectBuyOrderProduct} = useExchangeOrder();

  const handleSelectProduct = (
    product:
      | Database['public']['Functions']['get_product_position_aggregates']['Returns'][0]
      | Database['public']['Functions']['get_speculator_position_aggregates']['Returns'][0]
  ) => {
    switch (type) {
      case 'sell':
        selectSellOrderProduct(
          product as Database['public']['Functions']['get_speculator_position_aggregates']['Returns'][0]
        );
        break;
      case 'buy':
        selectBuyOrderProduct(product);
        break;
      case 'transfer':
        alert('Transfer not implemented');
        break;
    }

    // Close the modal
    const modal = document.querySelector('#hs-extralarge-modal');
    if (modal) {
      (window as any).HSOverlay.close(modal);
    }
  };

  return (
    <>
      <div id="hs-extralarge-modal" className="hs-overlay ti-modal hidden">
        <div className="ti-modal-box m-3 mt-0 flex h-[calc(100%-3.5rem)] min-h-[calc(100%-3.5rem)] items-center ease-out hs-overlay-open:mt-7 lg:!mx-auto lg:w-full lg:!max-w-4xl">
          <div className="ti-modal-content max-h-full overflow-hidden">
            <div className="ti-modal-body">
              <div className="grid grid-cols-12 gap-x-6">
                <div className="col-span-12 xxl:col-span-12">
                  <div className="box">
                    <div className="box-header justify-between">
                      <div className="box-title">Products</div>
                      <div className="flex">
                        <div className="me-3">
                          <input
                            className="form-control form-control-sm"
                            type="text"
                            placeholder="Search Here"
                            aria-label=".form-control-sm example"
                          />
                        </div>
                        <div className="ti-btn-list mr-3 flex gap-3">
                          {filterBtns.map(btn => (
                            <div className="ti-btn-group" key={btn.label}>
                              <div className="hs-dropdown ti-dropdown">
                                <button
                                  className={`ti-btn ti-btn-outline-${btn.class} ti-dropdown-toggle`}
                                  type="button"
                                  id="dropdownMenuButton2"
                                  aria-expanded="false"
                                >
                                  {btn.label}
                                  <i className="ri-arrow-down-s-line ms-1 inline-block align-middle"></i>
                                </button>
                                <ul
                                  className="hs-dropdown-menu ti-dropdown-menu hidden"
                                  aria-labelledby="dropdownMenuButton2"
                                >
                                  <li>
                                    <Link className="ti-dropdown-item" to="#">
                                      Action
                                    </Link>
                                  </li>
                                  <li>
                                    <Link className="ti-dropdown-item" to="#">
                                      Another action
                                    </Link>
                                  </li>
                                  <li>
                                    <Link className="ti-dropdown-item" to="#">
                                      Something else here
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          ))}
                        </div>

                        <div className="hs-dropdown ti-dropdown">
                          <Link
                            to="#"
                            className="ti-btn ti-btn-primary !m-0 !gap-0 !bg-primary !px-2 !py-1 !text-[0.75rem] !font-medium !text-white"
                            aria-expanded="false"
                          >
                            Sort By<i className="ri-arrow-down-s-line ms-1 inline-block align-middle"></i>
                          </Link>
                          <ul className="hs-dropdown-menu ti-dropdown-menu hidden" role="menu">
                            <li>
                              <Link
                                className="ti-dropdown-item block !px-[0.9375rem] !py-2 !text-[0.8125rem] !font-medium"
                                to="#"
                              >
                                New
                              </Link>
                            </li>
                            <li>
                              <Link
                                className="ti-dropdown-item block !px-[0.9375rem] !py-2 !text-[0.8125rem] !font-medium"
                                to="#"
                              >
                                Popular
                              </Link>
                            </li>
                            <li>
                              <Link
                                className="ti-dropdown-item block !px-[0.9375rem] !py-2 !text-[0.8125rem] !font-medium"
                                to="#"
                              >
                                Relevant
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="box-body">
                      <div className="table-responsive">
                        {type === 'buy' ? (
                          <DataTableRpc
                            staleTime={55000}
                            refetchInterval={60000}
                            functionName="get_product_position_aggregates"
                            functionArgs={{
                              p_market_id: marketId,
                              p_brand_id: brandId,
                            }}
                            ref={productRef}
                            sortOptions={[{column: 'item_count', direction: 'desc', label: 'Items'}]}
                            enabled={!!marketId && !!brandId}
                            columns={[
                              {
                                header: 'Product',
                                field: 'product_name',
                                render: row => (
                                  <div className="flex w-40 items-center">
                                    <img
                                      src={row.product_logo || row.brand_logo || '/images/logo/logo.png'}
                                      alt=""
                                      className="avatar avatar-md !mb-0 me-2 rounded-md leading-none"
                                    />
                                    <div>
                                      <p className="mb-0 font-semibold">
                                        <Link to="#" title="nft_name">
                                          {row.product_name}
                                        </Link>
                                      </p>
                                      <Link
                                        to="#"
                                        className="text-[0.75rem] font-normal text-[#8c9097] dark:text-white/50"
                                        title="creator_name"
                                      >
                                        {row.brand_name}
                                      </Link>
                                    </div>
                                  </div>
                                ),
                              },
                              {
                                header: 'Floor Price',
                                field: 'min_price',
                                render: row => <div>{row.min_price ? `$${row.min_price.toFixed(2)}` : 'N/A'}</div>,
                              },
                              {
                                header: 'Roof Price',
                                field: 'max_price',
                                render: row => <div>{row.max_price ? `$${row.max_price.toFixed(2)}` : 'N/A'}</div>,
                              },
                              {
                                header: 'Factored Price',
                                field: 'min_factored_price',
                                render: row => (
                                  <div>{row.min_factored_price ? `$${row.min_factored_price.toFixed(2)}` : 'N/A'}</div>
                                ),
                              },
                              {
                                header: 'Items',
                                field: 'item_count',
                              },
                            ]}
                            actions={[
                              {
                                color: 'primary',
                                icon: 'ri-check-line',
                                handler: row => handleSelectProduct(row),
                                permission: () => true,
                              },
                            ]}
                          />
                        ) : type === 'sell' ? (
                          <DataTableRpc
                            functionName="get_speculator_position_aggregates"
                            functionArgs={{
                              p_market_id: marketId,
                            }}
                            enabled={!!marketId}
                            columns={[
                              {
                                header: 'Product',
                                field: 'product_name',
                                render: row => (
                                  <div className="flex w-40 items-center">
                                    <img
                                      src={row.product_logo || row.brand_logo || '/images/logo/logo.png'}
                                      alt=""
                                      className="avatar avatar-md !mb-0 me-2 rounded-md leading-none"
                                    />
                                    <div>
                                      <p className="mb-0 font-semibold">
                                        <Link to="#" title="nft_name">
                                          {row.product_name}
                                        </Link>
                                      </p>
                                      <Link
                                        to="#"
                                        className="text-[0.75rem] font-normal text-[#8c9097] dark:text-white/50"
                                        title="creator_name"
                                      >
                                        {row.brand_name}
                                      </Link>
                                    </div>
                                  </div>
                                ),
                              },
                              {
                                header: 'Floor Price',
                                field: 'min_price',
                                render: row => <div>{row.min_price ? `$${row.min_price.toFixed(2)}` : 'N/A'}</div>,
                              },
                              {
                                header: 'Roof Price',
                                field: 'max_price',
                                render: row => <div>{row.max_price ? `$${row.max_price.toFixed(2)}` : 'N/A'}</div>,
                              },
                              {
                                header: 'Items',
                                field: 'item_count',
                              },
                            ]}
                            actions={[
                              {
                                color: 'primary',
                                icon: 'ri-check-line',
                                handler: row => handleSelectProduct(row),
                                permission: () => true,
                              },
                            ]}
                          />
                        ) : type === 'transfer' ? (
                          <div>Transfer</div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="ti-modal-footer">
              <button
                type="button"
                className="hs-dropdown-toggle ti-btn ti-btn-secondary-full"
                data-hs-overlay="#hs-extralarge-modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ProductSelectionModal;
